import { CButton, CInput, CInputCheckbox, CLabel } from '@coreui/react';
import moment from 'moment';
import * as React from 'react';
import { Table } from 'reactstrap';
import { IProgressParams, KActionList, KAttachment, KMultiScan, KProgress } from '../';
import { ControlTypeEnum, ICellDefinition, IDispatcher, IImageProvider, IRowDefinition } from '../../abstraction';
import { AppLabels } from '../../core/AppLabels';
import { IActionParam } from '../../core/dispatcher';
import { Utils } from '../../core/utils';
import multiscan from '../../img/BarcodeScanner.png';
import down from '../../img/down.png';
import empty from '../../img/empty.png';
import right from '../../img/right.png';
import { barCodeSvc, soundSvc } from '../../Karma';
import { ActionModel, ColumnModel, TableModel } from '../../models/index';
import { InternalTypeEnum } from '../../models/InternalTypeEnum';
import { IActionModel } from '../KActionList';
import { KControlAction, KInput } from './';

interface IProps {
	table: TableModel
	onRowSelected?: (table: TableModel, row: IRowDefinition) => void;
	onActionClicked: (table: TableModel, action: ActionModel, row: any) => void;
	onRowsAdded?: (table: TableModel, rows: any[]) => void;
	hideActionBar?: boolean;
	imageProvider: IImageProvider;
	dispatcher: IDispatcher;
}

interface IState {
	selectedIndex: string,
	selectedRow: IRowDefinition,

	sortCols: string;
	isRowDirty: boolean;

	isTreeViewMode: boolean;
	tree: ITreeViewItem[];
	virtualKeyboard: boolean;

	showButtonList: boolean;
	buttonList: ActionModel[];

	isMultiModeOpen: boolean;
	showEmbedded: boolean;
}

interface ITreeViewItem {
	level: number;
	isExpanded: boolean;
	id: string;
	parent: string;
	icon: string;
	children: ITreeViewItem[];
	data: any[];
}

export class KControlTable extends React.Component<IProps, IState> {
	private sortFlag: boolean = true;

	//#region Contructeur 

	public constructor(props: any) {
		super(props);

		let sort = this.props.table.DefaultSort;
		if (!sort) { sort = this.props.table.colsDef[0].Key; }

		// Analyse des propriétés liées au treeview
		// Si clé & clé parente renseignées, on passe en mode arborescent
		var tree: ITreeViewItem[] = [];
		var treeMode: boolean = false;
		if ((this.props.table.TreeViewKeyPath) && (this.props.table.TreeViewParentKeyPath)) {
			tree = this.buildNode("", 1);
			treeMode = true;
		}

		//
		let preselectedIndex = null

		if (this.props.table.Rows.length == 1) {
			if (this.props.table.TabAutoSelectSingleRow) {
				preselectedIndex = this.props.table.Rows[0]["_ID_"];
			}
		}

		let ctx = this.props.dispatcher.getLastViewContext();


		// Colonnes recherchables pour préselectionner une ligne du tableau
		if (preselectedIndex == null) {
			// Créer la liste des colonnes recherchables et la liste des choses à rechercher

			let colDefs = this.props.table.colsDef;
			let searchableCols = []; //liste des colonnes recherchables
			let whatToSearch = []; //liste des choses à rechercher

			Object.values(colDefs).forEach(col => {
				if (col.ColSearchField != "") {
					searchableCols.push(col.FieldName);
					let searchFieldName = col.ColSearchField;
					let valueToSearch = ctx.Controls.filter(control => control.Code == searchFieldName)[0].Value;
					if (valueToSearch) {
						whatToSearch.push(valueToSearch); // Ici récupérer le contenu de la zone trouvée ci-dessus
					}
					else searchableCols.pop();	// Pas de valeur à chercher, on supprime la colonne
				}
			});

			if (searchableCols.length > 0) {
				// Parcourir toutes les lignes du tableau
				let foundRows = 0;
				let savedRowNumber = "";
				Object.values(this.props.table.Rows).forEach(row => { //Parcourir toutes les lignes du tableau
					let found = true;
					for (let searchCol in searchableCols) { //Parcourir toutes les colonnes recherchables
						// si le contenu de la cellule ne correspond pas, on passe found à false
						if (found == true && whatToSearch[searchCol] != row[searchableCols[searchCol]]) found = false;
					}
					if (found == true) {
						foundRows++;
						savedRowNumber = row["_ID_"];
					}
				});
				if (foundRows == 1) preselectedIndex = savedRowNumber;
			}
		}

		if (preselectedIndex != null) {
			var selectedRow = this.props.table.Rows.filter(r => r["_ID_"] == preselectedIndex)[0];

			// BUG: Lors de la sélection auto de la seule ligne du tableau
			//  il faut renseigner la variable selectedRow

			// On change de ligne
			let sel: IRowDefinition = {
				key: this.props.table.Rows["_ID_"],
				columns: [],
			};

			this.props.table.colsDef.map(col => {
				let cell: ICellDefinition = {
					cellName: col.FieldName,
					cellValue: selectedRow[col.FieldName]
				}
				sel.columns.push(cell);
			});

			this.props.table.selectedRow = sel;
			this.setState({ selectedRow: sel });
			// Fin du correctif 

			this.props.table.actions.forEach(x => {
				if (x.Key == this.props.table.TabAutoSelectAction) { // Nouvel attribut à tester
					if (this.props.onActionClicked) {
						this.props.table.TabAutoSelectAction = "";
						this.props.onActionClicked(this.props.table, x, selectedRow);
					}
				}
			});
		}

		// Si une ligne est préselectionnée
		if (this.props.table.selectedRow) {

			// On va balayer chaque ligne du tableau pour retrouver celle sélectionnée
			// NON, on ne se base pas sur l'id, car il peut avoir changé entre 2 appels.
			// Par contre, on le stockera pour sélectionner la bonne ligne lors du rendu
			let rows = this.props.table.Rows;
			let colDefs = this.props.table.colsDef;

			let found = false;
			let sRow: IRowDefinition = this.props.table.selectedRow as IRowDefinition;

			// Double boucle qui scanne toutes les lignes puis chaque colonne
			// Le contenu de la cellule est comparé avec la ligne à sélectionner qui vient de x3.
			// Si l'une des données ne 'matche' pas, on passe à la ligne suivante
			// Si toutes les colonnes sont identiques, alors on récupère le _ID_ de la ligne et on arrête la recherche
			// On peut forcément faire plus simple ou plus joli.
			for (let iRowIndex = 0; iRowIndex < rows.length; iRowIndex++) {
				found = true;

				for (let iColIndex = 0; iColIndex < colDefs.length; iColIndex++) {
					let fieldName = colDefs[iColIndex].FieldName;

					let c = sRow.columns.filter(n => n.cellName == fieldName)[0];
					if (c) {
						if (c.cellValue != rows[iRowIndex][fieldName]) {
							found = false;
							break;
						}
					}
				}

				if (found) {
					preselectedIndex = rows[iRowIndex]["_ID_"]
					break;
				}
			}
		}



		// Init variable d'état
		this.state = {
			selectedIndex: preselectedIndex,
			selectedRow: this.props.table.selectedRow ? this.props.table.selectedRow : null,
			sortCols: sort,
			isRowDirty: false,
			isTreeViewMode: treeMode,
			tree: tree,
			virtualKeyboard: this.props.dispatcher.isVirtualKeyboardActive,
			showButtonList: false,
			buttonList: [],
			isMultiModeOpen: false,
			showEmbedded: ctx.ViewEmbeddedDoc,

		}

		// Signal générique reçu
		this.props.dispatcher.OnGenericAction.add(async (a: IActionParam) => {
			// Si ce signal est pour nous mais qu'il n'a pas été envoyé par nous (id différents), alors on déselectionne la ligne
			// 
			if (a.ActionCode == "TABSELECT") {
				let tab = a.Params as TableModel;
				if (tab) {
					if (this.props.table.Id != tab.Id) {

						// Si la ligne a subi des modifications
						if (this.state.isRowDirty) {
							if (! await this.props.dispatcher.ConfirmBox("", AppLabels.abandonUpdatesWarning, AppLabels.ok, AppLabels.cancel, 20)) {
								// On ne souhaite pas abandonner les modifs
								// Donc, on force la réselection de NOTRE ligne en déselectionnant les autres
								this.props.dispatcher.OnGenericAction.trigger({ ActionCode: "TABSELECT", Params: this.props.table });
								return;
							}

							// Perte des modifs -> On restaure les valeurs d'avant modif
							let currentRow = this.props.table.Rows.filter(c => c["_ID_"] == this.state.selectedIndex)[0];

							if (this.state.selectedIndex != null) {
								this.props.table.colsDef.map(col => {
									let cell = this.state.selectedRow.columns.filter(c => c.cellName == col.FieldName)[0];
									if (cell) {
										currentRow[col.FieldName] = col.PreviousValue;
									}
								});
							}
						}
						this.props.table.selectedRow = null;
						this.setState({ isRowDirty: false, selectedIndex: null, selectedRow: null });
					}
				}
			}
		});

		// Permet de mettre à jour le mode du clavier virtuel en cas de changement
		this.props.dispatcher.onVirtualKeyboardChanged.add((state) => { this.setState({ virtualKeyboard: state }) });

		//#region Fusion des données pour les colonnes fusionnées 

		// L'idée est de parcourir toutes les colonnes nécessitant une fusion (s'il y en a évidemment)
		//   Puis pour chaque ligne de donnée (row) on va récupérer la liste des colonnes à fusionner (ColMergeTargets.Split)
		//    et on recopie chaqué valeur dans la colonne cible (qui a pour id la somme des noms de colonnes)
		//
		try {
			this.props.table.colsDef.filter(c => c.ColMergeTargets).map(col => {

				// Récupère le caractère séparateur de colonne. S'il est vide, on met un espace
				if (col.ColMergeSeparator == "") col.ColMergeSeparator = " ";
				let colId = col.FieldName + "_" + col.ColMergeTargets.replace(";", "_");

				this.props.table.Rows.map(row => {
					row[colId] = row[col.FieldName];
					col.ColMergeTargets.split(";").map(t => { row[colId] = row[colId] + col.ColMergeSeparator + row[t] });
				});
			});
		}
		catch (err) {
			// Pas confiance...
			console.log("Error while merging cols");
			console.log(err);
		}

		//#endregion

	}

	//#endregion

	//#region React Hacks

	// Pour éviter un warning sur la console JS du navigateur, on se désabonne de l'évènement
	componentWillUnmount = () => {
		this.props.dispatcher.OnGenericAction.reset();
		this.props.dispatcher.onVirtualKeyboardChanged.reset();
	}

	//#endregion React Hacks

	//#region Local Events

	onActionClick = (action: ActionModel) => {
		if (this.props.onActionClicked) this.props.onActionClicked(this.props.table, action, this.state.selectedRow);
	}

	// Double click sur une ligne du tableau
	//
	onRowDblClick = async (row: any, index: number, rows: ITreeViewItem[]) => {

		if ((this.props.table.TabRowDblClick != undefined) && (this.props.table.TabRowDblClick != "")) {
			let action = this.props.table.actions.filter(a => a.Key == this.props.table.TabRowDblClick)[0];
			if ((action != undefined) && this.props.onActionClicked) {
				this.props.onActionClicked(this.props.table, action, row);
			}
			else {
				if (this.state.isTreeViewMode)
					if (rows) this.onExpandClick(rows[index]);
			}
		}
		else {
			if (this.state.isTreeViewMode)
				if (rows) this.onExpandClick(rows[index]);
		}
	}

	// Index = nouvelle ligne
	// row : ligne sélectionnée 
	onRowSelected = async (row: any, index: number) => {

		// On envoi un signal aux autres tableaux pour leur dire que la sélection est désormais chez nous
		this.props.dispatcher.OnGenericAction.trigger({ ActionCode: "TABSELECT", Params: this.props.table });

		// On a recliqué sur la même ligne (selectedIndex=ligne en cours) => sans effet
		if (row["_ID_"] == this.state.selectedIndex) return;

		// Si la ligne a subi des modifications à l'insu de son plein gré
		if (this.state.isRowDirty) {
			if (! await this.props.dispatcher.ConfirmBox("", AppLabels.abandonUpdatesWarning, AppLabels.ok, AppLabels.cancel, 20))
				return;

			// L'utilisateur a choisi la réponse D. 
			let currentRow = this.props.table.Rows.filter(c => c["_ID_"] == this.state.selectedIndex)[0];

			if (this.state.selectedIndex != null) {
				this.props.table.colsDef.map(col => {
					let cell = this.state.selectedRow.columns.filter(c => c.cellName == col.FieldName)[0];
					if (cell) {
						currentRow[col.FieldName] = col.PreviousValue;
					}
				});
			}
		}

		// On change de ligne
		let sel: IRowDefinition = {
			key: row["_ID_"],
			columns: [],
		};

		this.props.table.colsDef.map(col => {
			let cell: ICellDefinition = {
				cellName: col.FieldName,
				cellValue: row[col.FieldName]
			}
			sel.columns.push(cell);
		});

		this.props.table.selectedRow = sel;
		this.setState({ isRowDirty: false, selectedIndex: row["_ID_"], selectedRow: sel })

		// Stocke les valeurs de la nouvelle ligne pour pouvoir annuler
		this.props.table.colsDef.map(col => {
			col.PreviousValue = row[col.FieldName];
		});

		// Si évènement défini, on l'invoque
		if (this.props.onRowSelected) this.props.onRowSelected(this.props.table, sel);

		this.forceUpdate();
	}

	onInputChange = (value: string, row: any, code: string) => {
		// Mise à jour du champ de la ligne sélectionnée 
		this.props.table.selectedRow.columns.filter(c => c.cellName == code)[0].cellValue = value;
		row[code] = value;
		this.setState({ isRowDirty: true });
		this.forceUpdate();
	}

	// Clic sur entete de colonne
	onHeaderClick = (x: ColumnModel) => {
		let ascending = 1;

		// On récupère l'ordre de tri en cours (qui peut être 2 colonnes si initialisé depuis x3)
		// On ne retient que la 1ère colonne (via le split)
		// On va en déduire le sens (ascending 1 ou descending -1 si un - précède le nom de la colonne)
		// On supprimer l'éventuel  -
		let currentSort = this.state.sortCols.split(";")[0];
		if (currentSort) {
			if (currentSort.startsWith("-")) {
				ascending = -1;
				currentSort = currentSort.substring(1);
			}
		}

		// Si on a clique sur la même colonne que celle du tri, c'est qu'on souhaite inverser le sens
		if (currentSort == x.Key)
			ascending = ascending * -1;

		// On construit le nouveau critère de tri
		let newSort = "";
		if (ascending == -1) newSort = "-";
		newSort += x.Key;

		// On défini l'état & on autorise le tri
		this.sortFlag = true;
		this.setState({ sortCols: newSort });
	}

	// Sélection d'une action dans la liste définit dans onShortCutClick()
	// Si row est null, c'est qu'on a cliqué sur Annuler
	//
	onButtonListClose = (choice: IActionModel) => {
		this.setState({ showButtonList: false });

		if (choice) {
			let action = this.props.table.actions.filter(a => a.Key == choice.Key)[0];
			if (action) this.onActionClick(action);
		}
	}

	//#endregion Events

	//#region Méthodes métier

	// Compare deux valeur selon leur type
	private compare = (a, b, dataType: InternalTypeEnum, order: number = 1) => {
		switch (dataType) {
			case InternalTypeEnum.Date:
			case InternalTypeEnum.Datetime:
				{
					let val1 = moment(a, AppLabels.tabSortDateFormat).toDate();
					let val2 = moment(b, AppLabels.tabSortDateFormat).toDate();
					return (val1 > val2) ? order : -order
				}
			case InternalTypeEnum.Decimal:
			case InternalTypeEnum.Double:
			case InternalTypeEnum.Float:
				{
					let val1 = parseFloat(a);
					let val2 = parseFloat(b);
					return (val1 > val2) ? order : -order
				}
			case InternalTypeEnum.Short:
			case InternalTypeEnum.Long:
				{
					let val1 = parseInt(a);
					let val2 = parseInt(b);
					return (val1 > val2) ? order : -order
				}
			default:
				return (a > b) ? order : -order

		}
	}

	//
	sort = (sortCriteria: string) => {
		if (!this.sortFlag) return;
		this.sortFlag = false;

		let sortCols: string[] = [];
		let sortOrders: number[] = [];
		let dataTypes: InternalTypeEnum[] = [];
		let a: string;

		// On découpe les critères de sortie (si le tri est effectué sur plusieurs colonnes (2 MAX))
		sortCols = sortCriteria.split(";");

		sortCols.map((crit, index) => {
			if (crit.startsWith('-')) {
				sortOrders.push(-1);
				sortCols[index] = sortCols[index].substring(1);
			}
			else {
				sortOrders.push(1);
			}

			// Il faut supprimer le - pour ne garder que la clé de la colonne
			let colDef = this.props.table.colsDef.filter(c => c.Key == sortCols[index])[0];
			if (colDef == undefined) return; // Erreur sur une colone, pas de tri

			dataTypes.push(colDef.DataType);
		});

		// Tri sur la 1ère clé spécifiée
		let t1 = this.props.table.Rows.sort((a, b) => this.compare(a[sortCols[0]], b[sortCols[0]], dataTypes[0], sortOrders[0]));

		// Si tri sur une seule colonne, pas la peine de continuer
		if (sortCols.length == 1) {
			this.props.table.Rows = t1;
			return;
		}

		// On construit un tableau avec les clé de la colonne triée (sans doublon)
		let keys: any[] = [];
		t1.map(c => {
			if (keys.indexOf(c[sortCols[0]]) == -1) keys.push(c[sortCols[0]])
		});

		let t2: any[] = [];

		// On va maintenant balayer ce tableau de clé
		// Pour chaque clé, on récupère les enregisrement correspondant du tableau initial
		// Si plusieurs lignes sont retournées, on les tri à nouveau avec le 2ème critère
		// On doit certainement pouvoir faire bien mieux
		keys.map(key => {
			let items = t1.filter(f => f[sortCols[0]] == key);
			if (items.length == 1) {
				t2.push(items[0])
			}
			else {
				items.sort((a, b) => this.compare(a[sortCols[1]], b[sortCols[1]], dataTypes[1], sortOrders[1]))
					.map(t => t2.push(t));
			}
		});

		this.props.table.Rows = t2;
	}

	//#endregion 

	//#region Traitements métier TreeView

	// Construit un noeud de l'arbre avec ses enfants (récursif)
	//
	buildNode = (id: string, level: number): ITreeViewItem[] => {
		let items: ITreeViewItem[] = [];
		this.props.table.Rows.filter(f => f[this.props.table.TreeViewParentKeyPath] == id)
			.map((r, rowIndex) => {
				let item: ITreeViewItem = {
					level: level, // r[this.props.table.TreeViewLevelPath],
					id: r[this.props.table.TreeViewKeyPath],
					parent: r[this.props.table.TreeViewParentKeyPath],
					children: [],
					icon: r[this.props.table.TreeViewIconPath],
					isExpanded: r[this.props.table.TreeViewIsExpandedPath] == "1" ? true : false,
					data: r,
				};
				item.children = this.buildNode(item.id, level + 1);
				items.push(item);
			});
		return items;
	}

	// Applati un noeud de l'arbre pour faciliter l'affichage
	private TreetoArray(node: ITreeViewItem): ITreeViewItem[] {
		let tab: ITreeViewItem[] = [];

		tab.push(node);

		// Si le noeud est déplié, on ajoute les enfants
		if (node.isExpanded) {
			node.children.map(child => { tab = tab.concat(this.TreetoArray(child)) });
		}
		return tab;
	}

	onExpandClick = (row: ITreeViewItem) => {
		row.isExpanded = !row.isExpanded;
		row[this.props.table.TreeViewIsExpandedPath] = row.isExpanded ? "1" : "0";
		this.forceUpdate();
	}
	//#endregion Traitements métier

	//#region Rendus

	renderActionBar = () => {
		// On cache la barre de boutons
		if (this.props.hideActionBar) return;

		if (this.props.table.actions.filter(a => a.Visible == true).length == 0) return "";

		// A ne pas supprimer : la variable row peut en effet être utilisé depuis X3 via RowVisibilityCond
		let row = this.props.table.Rows.filter(c => c["_ID_"] == this.state.selectedIndex)[0];

		return (
			<div>
				<div className={"KControlTableButtonGroupHeader "}>
					<div className={"KControlTableButtonGroup "}>
						{
							this.props.table.actions.map((x, i) => {

								try {
									if (x.RowVisiblityCond) {
										if (!eval(x.RowVisiblityCond)) return null;
									}
								}
								catch (err) {
									console.log(err);
								}

								return (<KControlAction imageProvider={this.props.dispatcher} key={i} Action={x} onClick={(a) => { this.onActionClick(a) }} ></KControlAction>);
							}
							)}
					</div>
				</div>
			</div>
		)
	}

	// Clic sur un raccourci vers action (RUNACTIONLEFT ou RUNACTINMIDDLE)
	// Identique à GenView 
	onShortCutClick = (actionCodes: string) => {
		// Si pas de code, pourquoi traverserions nous la route ?
		if (!actionCodes) return;

		// Si plusieurs actions ont été définies dans l'attribut, on va aficher une fenêtre de sélection pour décider quelle action lancer
		let actions = actionCodes.split(";");
		if (actions.length > 1) {

			// On balaye les codes et on récupère les différents actions
			let list: ActionModel[] = [];
			for (let i = 0; i < actions.length; i++) {
				let action: ActionModel = this.props.table.actions.filter(x => x.Key == actions[i])[0];
				if (action) list.push(action);
			}

			// On affiche la liste de sélection
			this.setState({ buttonList: list, showButtonList: true });
			return;
		}

		// 1 Seul code => on clique directement
		let field: ActionModel = this.props.table.actions.filter(x => x.Key == actionCodes)[0];
		if (field) {
			this.onActionClick(field);
		}
	}

	renderActionIcon = (actionCodes: string, row: any) => {

		// Si pas de code, colonne vide
		if (!actionCodes) return (<td></td>)

		// Si plusieurs actions ont été définies dans l'attribut, on va aficher une fenêtre de sélection pour décider quelle action lancer
		let actions = actionCodes.split(";");
		if (actions.length > 1) {
			// On va afficher un bouton type '...' 
			// Lorsqu'on cliquera dessus, on affichera alors une liste de choix des actions possibles

			return (
				<td><CButton className="TabIcon" size="sm" type="submit" role="button" color="secondary" name="multiaction" onClick={() => { this.onShortCutClick(actionCodes) }} >
					...
				</CButton></td>);
		}

		// Si on arrive là, c'est qu'il n'y avait qu'un seul code
		let action = this.props.table.actions.filter(t => t.Key == actionCodes)[0];

		if (action == undefined) return (<td></td>);
		try {
			if (action.RowVisiblityCond) {
				if (!eval(action.RowVisiblityCond)) return (<td></td>);
			}
		}
		catch (err) {
			console.log(err);
		}

		return (
			<td><CButton className="TabIcon" size="sm" type="submit" role="button" color={action.Color} name={action.Key} onClick={() => { this.onActionClick(action) }} >
				<img src={this.props.imageProvider.getImg(action.Icon)} />
			</CButton></td>);
	}

	renderExpandIcon = (row: ITreeViewItem) => {
		// Si la ligne n'est pas dépliable, il faut prévoir un décalage avec une image vide pour rester visuellement aligné
		if (row.children.length == 0)
			return (<img src={empty} style={{ height: 1 }}></img>)

		// On affiche la bonne image selon que la ligne soit dépliée ou non
		if (row.isExpanded) {
			return (<img src={down} onClick={() => { this.onExpandClick(row) }}></img>)
		}
		return (<img src={right} onClick={() => { this.onExpandClick(row) }}></img>)
	}

	// Identique à genview
	renderButtonList = () => {
		if (!this.state.showButtonList) return "";

		return (
			<KActionList vertical={true} imageProvider={this.props.dispatcher} isOpen={this.state.showButtonList} title={AppLabels.selectActionTitle} choices={this.state.buttonList} closeCallBack={this.onButtonListClose} />
		);
	}

	onMultiModeClick = () => {
		this.setState({ isMultiModeOpen: true });
	}

	onMultiClosed = (submit: boolean, rows: any[]) => {
		this.setState({ isMultiModeOpen: false });
		if (submit)
			if (this.props.onRowsAdded) this.props.onRowsAdded(this.props.table, rows);
	}

	renderMultiScan = () => {
		if (this.state.isMultiModeOpen) return (
			<KMultiScan soundSvc={soundSvc} barCodeSvc={barCodeSvc} dispatcher={this.props.dispatcher} msgboxProvider={this.props.dispatcher} virtualKeyboardProvider={this.props.dispatcher} closeCallBack={this.onMultiClosed} isOpen={true} table={this.props.table} />
		);
		return "";
	}

	render() {
		let table = this.props.table;
		if (!table.Visible) return null;

		let rows: ITreeViewItem[] = [];

		if (this.state.isTreeViewMode) {
			this.state.tree.map(node => {
				rows = rows.concat(this.TreetoArray(node))
			});
		}
		else {
			this.sort(this.state.sortCols);

			table.Rows.map((row, rowId) => rows.push({
				id: rowId.toString(),
				children: [],
				icon: "",
				isExpanded: true,
				level: 1,
				parent: "",
				data: row,
			}))
		}


		// Ne pas supprimer => Formules X3				\/
		let ctx = this.props.dispatcher.getLastViewContext();		// Contexte de la page
		let fields: any[] = [];										// Champs de la page

		// On recopie les valeurs pour les mettre à disposition de X3 dans les formules
		ctx.Controls.map(c => fields[c.Code] = c.Value);
		// Ne pas supprimer => Formules X3				/\

		let inlineStyle = Utils.decodeInlineStyleFromJson(table.InlineStyle);

		let actionBar = (this.state.selectedIndex != null) ? this.renderActionBar() : "";
		let headerTreeView = this.state.isTreeViewMode ? <th className={"KTableHeaderCol "} key="_tree"><div className="thContent"> </div></th> : null;
		let headerAction1 = (table.TabAction1 != undefined && table.TabAction1 != "") ? <th className={"KTableHeaderCol action"}></th> : null;
		let headerAction2 = (table.TabAction2 != undefined && table.TabAction2 != "") ? <th className={"KTableHeaderCol action"}></th> : null;

		let buttonList = this.renderButtonList();

		let multiScan = this.renderMultiScan();
		let multiScanIcon = table.NormBarcod ? <img className="KMultiScan" src={multiscan} onClick={() => { this.onMultiModeClick() }} /> : ""

		let sortCrit = this.state.sortCols.split(";")[0];
		let ascending = 1;
		if (sortCrit.startsWith("-")) {
			ascending = -1;
			sortCrit = sortCrit.substring(1);
		}

		return (
			<React.Fragment>
				<CLabel className="KLabelTable" htmlFor={this.props.table.Key} >{this.props.table.title}</CLabel>
				{multiScanIcon}
				<div className={"KControlTable " + (this.state.isTreeViewMode ? " KTreeView " : "")} style={inlineStyle} >
					<Table size="sm" >
						<thead>
							<tr>
								{headerTreeView}
								{headerAction1}
								{headerAction2}
								{
									table.colsDef.filter(c => c.Visible).map((x, i) => {
										if (x.Class == undefined) x.Class = "";
										let sorted = (!this.state.isTreeViewMode && x.Key == sortCrit) ? (ascending == -1 ? " sorted_descending " : " sorted_ascending ") : "";
										return (
											<th onClick={() => { this.onHeaderClick(x) }} className={"KTableHeaderCol " + x.Class} key={i}><div className="thContent">{x.Title}<div className={sorted}></div></div></th>
										)
									}
									)
								}
							</tr>
						</thead>
						<tbody>
							{
								rows.map((treeRow, rowIndex) => {

									let row = treeRow.data;

									let bgColor: string = "";
									try {
										if (table.BgRedCond != "") { if (eval(table.BgRedCond)) bgColor += " Red" }
										if (table.BgOrangeCond != "") { if (eval(table.BgOrangeCond)) bgColor += " Orange" }
										if (table.BgYellowCond != "") { if (eval(table.BgYellowCond)) bgColor += " Yellow" }
										if (table.BgGreenCond != "") { if (eval(table.BgGreenCond)) bgColor += " Green" }
									}
									catch (err) {
										console.log(AppLabels.inlineStyleError + "(line " + rowIndex + ")");
										bgColor = "";
										console.error(err);
									}

									let expandIcon = this.renderExpandIcon(treeRow);
									let isRowSelected = (this.state.selectedIndex == row["_ID_"]);
									let action1 = (headerAction1 == null) ? null : isRowSelected ? this.renderActionIcon(table.TabAction1, row) : <td></td>
									let action2 = (headerAction2 == null) ? null : isRowSelected ? this.renderActionIcon(table.TabAction2, row) : <td></td>

									let inlineStyle = this.state.isTreeViewMode ? { paddingLeft: 10 * (treeRow.level - 1) + 3 } : {}

									let treeIcon = (headerTreeView == null) ? null : <td style={{ paddingLeft: 10 * (treeRow.level - 1), width: 1 }}>{expandIcon}<img src={this.props.imageProvider.getImg(treeRow.icon)} onClick={() => { this.onExpandClick(treeRow) }} /></td>

									return (
										<tr className={((isRowSelected == true) ? "selected" : "") + " " + bgColor} key={rowIndex} onDoubleClick={() => { this.onRowDblClick(row, rowIndex, rows) }} onClick={() => { this.onRowSelected(row, rowIndex) }}>
											{treeIcon}
											{action1}
											{action2}
											{
												table.colsDef.filter(column => column.Visible).map((column, j) => {
													let css = column.Class;
													if (css == undefined) css = "";
													if (css == "undefined") css = "";

													let canEditField = false;
													try {
														if (column.RowEditCond) { canEditField = eval(column.RowEditCond); }
													}
													catch (err) {
														console.log(err);
													}


													if (canEditField && isRowSelected && (column.Disable == false)) {
														// nous somme en modification sur la ligne

														// On stocke la valeur d'origine pour pouvoir gérer le 'Annuler'
														column.Value = row[column.Key];

														// Selon le type de la colonne, on va afficher le bon controle
														switch (column.Type) {

															case ControlTypeEnum.document:
																return (
																	<td className={"KTableCol " + css} key={j}><KAttachment drawMode={false} msgboxProvider={this.props.dispatcher} embedded={this.state.showEmbedded} imageProvider={this.props.dispatcher} description={column.Title} path={column.Value} visible={column.Visible} ></KAttachment></td>
																)
															case ControlTypeEnum.input:
																return (
																	<td className={"KTableCol " + css} key={j}><KInput Control={column} onChange={(e) => { this.onInputChange(e, row, column.Key) }}></KInput></td>
																)
															case ControlTypeEnum.select:
															case ControlTypeEnum.selectControled:
															case ControlTypeEnum.selectFree:
																return (
																	<td className={"KTableCol " + css} key={j}><CInput size="sm" onChange={(e) => { this.onInputChange(e.currentTarget.value, row, column.Key) }} value={row[column.Key]} inputMode={!this.state.virtualKeyboard ? "none" : "text"} > </CInput></td>
																)
															case ControlTypeEnum.checkbox:
																return (
																	<td className={"KTableCol " + css} key={j}><input checked={row[column.Key] == "2" ? true : false} type="checkbox" onClick={(e) => { this.onInputChange((e.target as HTMLInputElement).checked ? "2" : "1", row, column.Key) }} ></input></td>
																)
															default:
																return (<td></td>)
														}
													}
													else {

														// Selon le type de la colonne, on va afficher le bon controle
														switch (column.Type) {
															case ControlTypeEnum.document:
																// Récupère l'extension du fichier
																// pour l'afficher en description
																let fullPath: string = row[column.Key];
																let extensions = fullPath.split('.');
																let extension = "FILE";
																if (extensions.length > 1) {
																	extension = "." + extensions[extensions.length - 1].toUpperCase();
																}

																return (<td className={"KTableCol " + css} style={inlineStyle} key={j}><KAttachment embedded={this.state.showEmbedded} showMoreIcon={column.ShowMoreIcon} drawMode={false} msgboxProvider={this.props.dispatcher} imageProvider={this.props.dispatcher} description={extension} path={row[column.Key]} visible={column.Visible} ></KAttachment></td>)

															case ControlTypeEnum.progress:
																return (<td className={"KTableCol " + css} style={inlineStyle} key={j}><KProgress Value={row[column.Key]} ctrl={column as IProgressParams}></KProgress></td>)

															case ControlTypeEnum.checkbox:
																return (<td className={"KTableCol " + css} style={inlineStyle} key={j}><input disabled type="checkbox" checked={(row[column.Key] as string) == "2" ? true : false}></input></td>)

															default:
																return (<td className={"KTableCol " + css} style={inlineStyle} key={j}>{row[column.Key]}</td>)
														}
													}
												}
												)
											}
										</tr>
									)
								})
							}
						</tbody>
					</Table>
					{buttonList}
					{actionBar}
					{multiScan}
				</div>
			</React.Fragment>
		)
	}

	//#endregion 

}